import React from 'react';
import { View, Text } from '@adobe/react-spectrum';
import './AgentGroupStyle.css';

const HierarchyItem = ({ item, level, isLast }) => {
  const indentation = level * 48;

  return (
    <View
      UNSAFE_className="hierarchy-item"
      UNSAFE_style={{
        paddingLeft: `${indentation}px`,
      }}
    >
      {/* Vertical connection line */}
      {level > 0 && (
        <div
          className="vertical-line"
          style={{
            left: `${indentation - 24}px`,
          }}
        />
      )}

      {/* Horizontal connection line */}
      {level > 0 && (
        <div
          className="horizontal-line"
          style={{
            left: `${indentation - 24}px`,
          }}
        />
      )}

      {/* Content box */}
      <View
        UNSAFE_className="content-box"
      >
        <View flex="1">
          <Text
            UNSAFE_className="item-name"
          >
            {`${item.label} - ${item.name}`}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default HierarchyItem;
